import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import FileBase64 from 'react-file-base64';
import $ from 'jquery';
import Loader from '../../Loader';
import StaffPage from '../../views/StaffPage/';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class Employee extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			cid : '',
			design : [],
			depart : [],
			types : [],
			posts : [],
			sta : [],
			clas: [],
			empcode : '',
			joindate : '',
			dept : '',
			desig  : '',
			quali : '',
			user : '',
			ename : '',
			dob : '',
			gender : '',
			presentaddr : '',
			permanentaddr : '',
			city : '',
			pincode : '',
			country : '',
			state : '',
			mobile : '',
			phone : '',
			email : '',
			files : [],
			_message : '',
			alertClass :'',
			region : '',
			_redirect : false,
			employees : [],
			classs : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBack = this.onBack.bind(this);
		this.handleClassChange = this.handleClassChange.bind(this);
	}
	
	handleClassChange(value) {

		this.setState({ classs: value });
	}
	
	//base64 photo
	getFiles(files){
		this.setState({ files: files })
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	onClick(e){
		
		document.getElementById("empform").reset();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
	}
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('employee/add',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				/* this.setState({
					_message:'Employee Details Added Successfully!..',
					alertClass:'alert alert-success',
				}); */
				alert('Employee Details Added Successfully!..');
				document.getElementById("empform").reset();
				this.getemployeecode();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
		this.getdepartment();
		this.getdesignation();
		this.getusertype();
		this.getcountry();
		this.getstate();
		this.getemployeecode();
		this.getemployees();
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					clas: responseJson
				});
			}
		});
	}
	
	getemployees(){
		$("#showLoader").show();
		GetData('employee/getemployee').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					employees : responseJson
				});
				//$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}	

	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Designation **/
	getdesignation(){
		
		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					design : responseJson
				});
			}
		});
	}
	
	/** get Employee Code **/
	getemployeecode(){
		
		GetData('employee/getemployeecode').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					empcode : responseJson
				});
			}
		});
	}
	
	/** get usertype **/
	getusertype(){
		
		GetData('usertype/getusertype').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					types : responseJson
				});
			}
		});
	}
	
	/** get country **/
	getcountry(){
		
		GetData('home/getcountry').then((result) => {
			let res = result;
			if(res){
				this.setState({posts:res,cid : res[0]['id']});
			}
		});
	}
	
	/** get state **/
	getstate(){
		$("#showLoader").show();
		GetData('home/getstate').then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({sta:res});
			}
		});
	}
	
	selectCountry (val) {
		this.setState({ country: val });
	}
 
	selectRegion (val) {
		this.setState({ region: val });
	}
	
  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to='/employee/list' />);
	}
	
	  const { country, region } = this.state;
	  
	  var dept = this.state.depart;
	  var desi = this.state.design;
	  var utype = this.state.types;
	  var items = this.state.posts;
	  var stat = this.state.sta;
	  
	  this.gen = [
		{value : '', name : 'Select Gender'},
		{value : 'Male', name : 'Male'},
		{value : 'Female', name : 'Female'}
	  ];
	  
		var clss = [];
		this.state.clas.map(function (e, key) {
			clss.push(
				{ value: e.id, label: e.class }
			);
		});
	  
    return (
		<div>
		  <StaffPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
					<Card>
					  <form action="" method="post" role="form" id="empform" encType="multipart/form-data" onSubmit={this.onSubmit} >
						<CardHeader>
							<strong>Employee Registration</strong>
							<span className="pull-right">
								<Button outline color="primary" onClick={this.onBack}>Back to Employee List</Button>
							</span>
						</CardHeader>
						<CardBody>
						<h5>Employee Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Employee Code <span className="text-danger">*</span></Label>
								  <Input type="text" name="empcode" required onChange={this.onChange} value={this.state.empcode} disabled />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Joining Date</Label>
								  <Input type="date" name="joindate" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Department</Label>
								  <select name="dept" onChange={this.onChange} className="form-control">
									<option value="">Select Department</option>
									{
										dept.map(function (item) {
											return <option value={item.id }>{item.department}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Designation</Label>
								  <select name="desig" onChange={this.onChange} className="form-control">
									<option value="">Select Designation</option>
									{
										desi.map(function (item) {
											return <option value={item.id }>{item.designation}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Qualification</Label>
								  <Input type="text" name="quali" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
									<Label htmlFor="name">Classes</Label>
									<Select value={this.state.classs} id="classs" onChange={this.handleClassChange} multi options={clss} />
								</FormGroup>
							  </Col>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">User Type <span className="text-danger">*</span></Label>
								  <select name="user" onChange={this.onChange} required className="form-control">
									<option value="">Select UserType</option>
									{
										utype.map(function (item) {
											return <option value={item.id }>{item.usertype}</option>;
										})
									}
								  </select>
								</FormGroup>
								</Col>
								<Col md="3">
									<FormGroup>
										<Label htmlFor="name">Category</Label>
										<select name="category" className="form-control" onChange={this.onChange} >
											<option value="">Select Category</option>
											<option value="Nursery">Nursery</option>
											<option value="Pre-Primary">Pre-Primary</option>
											<option value="Primary">Primary</option>
											<option value="Middle">Middle</option>
											<option value="High">High</option>
											<option value="Senior Secondary">Senior Secondary</option>
										</select>
									</FormGroup>
								</Col>
								<Col md="1">
									<FormGroup>
										<Label htmlFor="name">Classes</Label>
									</FormGroup>
								</Col>
							</Row>
							<h5>Personal Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Employee Name <span className="text-danger">*</span></Label>
								  <Input type="text" name="ename" required onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Date of Birth</Label>
								  <Input type="date" name="dob" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Gender <span className="text-danger">*</span></Label>
								  <select name="gender" className="form-control" onChange={this.onChange} required>
									{this.gen.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								  </select>
								</FormGroup>
							  </Col>
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Father/Spouse Name</Label>
								  <Input type="text" name="fathername" onChange={this.onChange} />
								</FormGroup>
							  </Col>
								<Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Father/Spouse Mobile</Label>
								  <Input type="text" name="fathermobile" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							</Row>
							<h5>Contact Details</h5><hr className="line"></hr>
							<Row>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Present Address</Label>
								  <Input type="textarea" name="presentaddr" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Permanent Address </Label>
								  <Input type="textarea" name="permanentaddr" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">City </Label>
								  <Input type="text" name="city" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Pincode </Label>
								  <Input type="number" name="pincode" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Country</Label>
								  <CountryDropdown value={country} onChange={(val) => this.selectCountry(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">State</Label>
								  <RegionDropdown country={country} value={region} onChange={(val) => this.selectRegion(val)} id="con" />
								</FormGroup>
							  </Col>
							   <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Mobile</Label>
								  <Input type="number" name="mobile" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Phone</Label>
								  <Input type="number" name="phone" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Email </Label>
								  <Input type="email" name="email" onChange={this.onChange} />
								</FormGroup>
							  </Col>
							  <Col md="6">
								<FormGroup>
								  <Label htmlFor="name">Upload Photo </Label>
								  <FormGroup>
									<FileBase64 onDone={ this.getFiles.bind(this) } />
								  </FormGroup>
								</FormGroup>
							  </Col>
							</Row>
							<h5>Other Details</h5><hr className="line"></hr>
							<Row>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Aadhar No </Label>
										<Input type="number" name="aadhar" onChange={this.onChange} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Pan No </Label>
										<Input type="number" name="panno" onChange={this.onChange} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">PF No </Label>
										<Input type="number" name="pfno" onChange={this.onChange} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">ESI No </Label>
										<Input type="number" name="esino" onChange={this.onChange} />
									</FormGroup>
								</Col>
								<Col md={4}>
									<FormGroup>
										<Label htmlFor="name">Refered Staff </Label>
										<Input type="text" list="slist" name="reference" onChange={this.onChange} />
										<datalist id="slist">
											{this.state.employees.map((item,i)=>
													<option value={item.empname}></option>
												)}
										</datalist>
									</FormGroup>
								</Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Employee;


// WEBPACK FOOTER //
// ./src/employee/Employee/Employee.js